import React from "react";
import AccordionSummary from "./AccordionSummary";
import AccordionDetails from "./AccordionDetails";
import { useSynchronizedState } from "@solidwhite/multiuser";

type AccordionComponentProps = {
  iconColor: string;
  summaryBackgroundColor: string;
  summaryTextColor: string;
  detailsBackgroundColor: string;
  detailsTextColor: string;
  contentArray: Array<any>;
  contentId: string;
};

export const AccordionComponent: React.FunctionComponent<AccordionComponentProps> = (props: AccordionComponentProps) => {
  const {
    iconColor,
    detailsBackgroundColor,
    summaryBackgroundColor,
    summaryTextColor,
    detailsTextColor,
    contentArray,
    contentId,
  } = props;
  const [expanded, setExpanded] = useSynchronizedState(`accordion_${contentId}`, 0);

  const handler = (id: any) => {
    setExpanded(id);
  };

  React.useEffect(() => {
    if (contentArray !== []) {
      setExpanded(contentArray[0].id);
    }
  }, [contentArray]);

  return (
    <div>
      {contentArray !== [] &&
        contentArray.map((section) => (
          <div key={section.id}>
            <AccordionSummary
              section={section}
              expanded={expanded}
              summaryTextColor={summaryTextColor}
              summaryBackgroundColor={summaryBackgroundColor}
              iconColor={iconColor}
              handler={handler}
            />
            <AccordionDetails
              section={section}
              expanded={expanded}
              detailsBackgroundColor={detailsBackgroundColor}
              detailsTextColor={detailsTextColor}
            />
          </div>
        ))}
    </div>
  );
};
